export const AUTO_LANGUAGE = {
  auto_shelf_plans_add_info_title: "Information",
  auto_shelf_plans_add_coverages_title: "Coverage",
  auto_shelf_plans_coverage_coverage_type: "Coverage Type",
  auto_shelf_plans_coverage_benefit_value: "Benefit Value",
  auto_shelf_plans_add_coverages_coverages: "Select Coverages",
  auto_shelf_plans_add_coverages_coverages_error: "Coverages are required",

  auto_shelf_plans_add_coverages_benefit: "Benefit",
  auto_shelf_plans_add_coverages_benefit_error: "Benefit is required",

  auto_shelf_plans_add_coverages_description: "Description",
  auto_shelf_plans_add_coverages_description_error: "Description is required",
  auto_shelf_plans_add_coverages_description_error_max_length: "Description should be under 500 characters",

  auto_shelf_plans_coverage_sub_child: "Sub-Child",
  auto_shelf_plan_listing_title: "Shelf Plans",
  auto_shelf_plans_add_price_setup_title: "Price Setup",
  auto_shelf_plans_service_listing_title: "Services",
  auto_shelf_plans_service_add_service_title: "Add Service",
  auto_shelf_plans_services_listing_priority_order: "Priority Order",
  auto_shelf_plans_services_listing_service_name: "Service Name",
  auto_shelf_plans_services_listing_provider_name: "Provider Name",
  auto_shelf_plans_services_listing_sub_services: "Sub-Services",
  auto_shelf_plans_add_service_select_provider: "Select Provider",
  auto_shelf_plans_add_service_select_provider_required_error: "Select Provider is required",

  auto_shelf_plans_add_service_select_provider_takaful_provider: "Takaful Provider",
  auto_shelf_plans_add_service_select_provider_service_provider: "Service Provider",
  auto_shelf_plans_add_service_search_service: "Search Service",
  auto_shelf_plans_add_service_search_service_required_error: "Search Service is required",
  auto_shelf_plans_add_service_service_heading: "Service",
  auto_shelf_plans_add_service_sub_service_heading: "Sub Service",

  auto_shelf_plans_add_price_unsaved_data_discard_warning: "Your changes will discard. Do you want to continue?",
  auto_shelf_plan_listing_add: "Add",
  auto_shelf_plan_name: "Name",
  auto_shelf_plan_product_name: "Product Name",
  auto_shelf_plan_takaful_provider: "Takaful Provider",
  auto_shelf_price_type: "Price Type",
  auto_shelf_plan_type: "Plan Type",
  auto_shelf_plan_duration: "Duration",
  auto_shelf_plans_add_info_plan_type: "Plan Type",
  auto_shelf_plans_add_info_plan_type_required_error: "Plan type is required",
  auto_shelf_plans_add_info_taxation_type: "Taxation type",
  auto_shelf_plans_add_info_is_fixed_price: "Is Fixed Price",
  auto_shelf_plans_add_info_instant_cover_note: "Instant cover note",
  auto_shelf_plans_add_info_instant_cover_note_required_err: "Instant cover note is required",
  auto_shelf_plans_add_info_taxation_type_required_type: "Taxation type is required",
  auto_shelf_plans_add_info_plan_name: "Plan Name",
  auto_shelf_plans_add_info_plan_name_required_error: "Plan name is required",
  auto_shelf_plans_add_info_plan_name_length_error: "Plan name must be less than 50 characters",
  auto_shelf_plans_add_info_product_name: "Product Name",
  auto_shelf_plans_add_info_product_name_required_error: "Product name is required",
  auto_shelf_plans_add_info_product_name_length_error: "Product name must be less than 50 characters",
  auto_shelf_plans_add_info_takaful_provider: "Takaful Provider",
  auto_shelf_plans_add_info_takaful_provider_required_error: "Takaful provider is required",
  auto_special_character_validation_error: "Field does not not contain special characters",

  /* sale point start */

  auto_plans_sale_point: "Sale Point",
  auto_plans_select_sale_point: "Select Salepoint",
  auto_plans_select_sale_point_error: "Please select salePoint",
  auto_shelf_plan_add_about_this_plan_description_label: "Description",

  /* sale point ends */
  auto_about_plan_heading: "Heading",
  auto_about_plan_description: "Description",
  auto_about_plan_video_url: "Video Url",
  auto_plans_about_this_plan_title: "About This Plan",
  auto_plan_about_this_plan_heading: "Heading",
  auto_plan_about_this_plan_video_url: "Video URL",
  auto_plan_add_about_this_plan_label: "Heading",
  auto_plan_add_about_this_plan_placeholder: "Enter Heading",
  auto_plan_add_about_this_plan_label_required_err: "Heading is required",
  auto_plan_add_about_this_plan_label_length_err: "Heading should be under 50 characters",
  auto_plan_add_about_this_plan_description_length_err: "Description should be under 700 characters",
  auto_plan_add_about_this_plan_video_url_label: "Video URL",
  auto_plan_add_about_this_plan_video_url_required: "Video URl is required",
  auto_plan_document_label: "Documents",
  auto_shelf_plans_add_documents_title: "Documents",
  auto_shelf_plans_add_documents_listing_document_name: "Document Name",
  auto_shelf_plan_listing_add_documents_add_button: "Add Documents",
  auto_plan_add_about_this_plan_label_description_required_err: "Description is required",

  auto_shelf_plans_depreciation_title: "Depreciation",
  auto_shelf_plans_depreciation_add_date_range: "Date Range",
  auto_shelf_plans_depreciation_add_percentage: "Percentage",
  auto_shelf_plans_depreciation_add_description: "Description",
  auto_shelf_plans_depreciation_add_description_max_length_error: "Description must be less than 500 characters",
  auto_shelf_plans_depreciation_add_percentage_min_length_error: "Percentage must be positive",
  auto_shelf_plans_depreciation_add_percentage_decimal_points_error: "Percentage must contain only 2 decimal points",
  auto_shelf_plans_depreciation_add_percentage_max_length_error: "Percentage must be less than or equal to 100",
  auto_shelf_plans_depreciation_add_min_range_min_length_error: "Date Range Min must be positive",
  auto_shelf_plans_depreciation_add_min_range_min_decimal_error: "Date Range Min must not have decimal points",
  auto_shelf_plans_depreciation_add_min_range_required_error: "Date Range Min is required",
  auto_shelf_plans_depreciation_add_max_range_required_error: "Date Range Max is required",
  auto_shelf_plans_depreciation_add_max_range_type_required_error: "Date Range Max Duration Type is required",
  auto_shelf_plans_depreciation_add_percentage_required_error: "Percentage is required",
  auto_shelf_plans_depreciation_add_min_range_type_required_error: "Date Range Min Duration Type  is required",
  auto_shelf_plans_depreciation_duplicate_date_range_error: "Duplicate Entry",
  auto_shelf_plans_depreciation_add_max_range_min_decimal_error: "Date Range Max must not have decimal points",
  auto_shelf_plans_depreciation_add_min_range_max_decimal_error: "Date Range Max must not have decimal points",
  auto_shelf_plans_depreciation_add_percentage_decimal_error: "Percentage must not contains more than two decimal points",
  auto_shelf_plans_depreciation_add_min_range_max_length_error: "Date Range Min must be less than 99",
  auto_shelf_plans_depreciation_add_max_range_min_length_error: "Date Range Max must be positive",
  auto_shelf_plans_depreciation_add_max_range_max_length_error: "Date Range Max must be less than 99",
  auto_shelf_plans_depreciation_add_depreciation_table_heading: "Depreciation Table",
  auto_shelf_plans_depreciation_add_depreciation_date_range_min_greater_max_error: "Date Range Max must be greater than Date Range Min",
  auto_shelf_plans_depreciation_add_depreciation_date_range_min_and_max_not_same_error: "Date Range Min Type and Date Range Max Type must be same",

  /* sale point ends */
  auto_shelf_plans_required_documents_title: "Required Documents",
  auto_shelf_plans_add_required_documents_title: "Add Required Document",
  auto_shelf_plans_edit_required_documents_title: "Edit Required Document",
  auto_shelf_plans_add_required_documents_listing_document_name: "Document Name",
  auto_shelf_plans_add_required_documents_listing_document_supportedFormats: "Supported Formats",
  auto_shelf_plans_add_required_documents_modal_name: "Document Name",
  auto_shelf_plans_add_required_documents_modal_name_required_error: "Document Name is required",
  auto_shelf_plans_add_required_documents_modal_name_length_error: "Document Name should be under 25 characters",
  auto_shelf_plans_add_required_documents_modal_name_empty_space_error: "Document Name is invalid",
  auto_shelf_plans_add_required_documents_modal_name_special_character_error: "Document Name should not contain special characters or numbers",
  auto_shelf_plans_add_required_documents_modal_supported_format: "Supported Formats",
  auto_shelf_plans_add_required_documents_modal_supported_format_required_error: "Supported Format is required",
  auto_shelf_plans_add_plan_exclusion_title: "Plan Exclusion",
  auto_shelf_plans_listing_plan_exclusion_exclusion_type: "Exclusion Type",
  auto_shelf_plans_listing_plan_exclusion_exclusion_value: "Exclusion Value",
  auto_shelf_plans_listing_plan_exclusion_sub_child: "Sub-Child",

  auto_shelf_plans_add_plan_exclusion_exclusion: "Select Exclusion",
  auto_shelf_plans_add_plan_exclusion_exclusion_error: "Exclusion is required",
  auto_shelf_plans_add_plan_exclusion_description: "Description",
  auto_shelf_plans_add_plan_exclusion_description_error: "Description is required",
  auto_shelf_plans_add_plan_exclusion_benefit: "Benefit",
  auto_shelf_plans_add_plan_exclusion_benefit_error: "Benefit is required",
  auto_shelf_plans_add_plan_exclusion_description_error_max_length: "Description should be under 500 characters",
  auto_shelf_plans_pre_existing_conditions_add_year_description: "Description",
  auto_shelf_plans_pre_existing_conditions_add_year_description_error_max_length: "Description should be under 250 characters",
  auto_order_listing_order_date: "Order Date",
  auto_order_listing_order_id: "Order Id",
  auto_order_listing_policy_id: "Policy ID",
  auto_order_listing_name: "Name",
  auto_order_listing_sale_point: "Sale Point",
  auto_order_listing_takaful_provider: "Takaful Provider",
  auto_order_listing_plan_name: "Plan Name",
  auto_order_listing_product_name: "Product Name",
  auto_order_listing_plan_type: "Plan Type",
  auto_order_listing_services_provider: "Services Provider",
  auto_order_listing_services: "Services",
  auto_order_listing_contribution: "Contribution",
  auto_order_listing_payment_status: "Payment Status",
  auto_order_listing_policy_status: "Policy Status",
  auto_order_listing_policy_issue_date: "Policy Issue Date",
  auto_order_listing_policy_expiry_date: "Policy Expiry Date",
  auto_order_listing_last_updated: "Last Updated",
  auto_order_listing_title: "Auto Orders",
  auto_order_download_export_to_excel: "Export to Excel",
  auto_order_information: "Information",
  auto_order_dealership_details: "Dealership Details",
  auto_order_dealership_name: "Partner Name",
  auto_order_dealership_premises_name: "Dealership Name",
  auto_order_dealership_agent_name: "Agent Name",
  auto_order_dealership_selected_rate: "Selected Rate(%)",
  auto_order_dealership_incentive_mode: "Incentive Mode",
  auto_order_dealership_calculated_incentive: "Calculated Incentive",

  auto_order_name: "Name",
  auto_order_maiden_name: "MOther's Maiden Name",

  auto_order_personal_details: "Personal Details",
  auto_order_customer_details_title: "Customer Details",
  auto_order_father_and_spouse_name: "Father / Spouse Name",
  auto_order_cnic_number: "CNIC Number",
  auto_order_cnic_issue_date: "CNIC Issue Date",
  auto_order_cnic_expiry_date: "CNIC Expiry Date",
  auto_order_date_of_birth: "Date of Birth",
  auto_order_father_spouse_name: "Father / Spouse Name",
  auto_order_cnic_cnic_life_time_expiry: "Lifetime",
  auto_order_occupation_error: "Occupation is required",
  auto_order_nationality: "Nationality",
  auto_order_nationality_error: "Nationality is required",
  auto_order_occupation: "Occupation",
  auto_order_customer_details: "Customer Details",
  auto_order_customer_details_edit: "Edit",
  auto_order_contact_details: "Contact Details",
  auto_order_contact_number: "Contact Number",
  auto_order_email_address: "Email Address",
  auto_order_address: "Address",
  auto_order_previous_insurance_details: "Previous Insurance Details",
  auto_order_previous_insurance_company_name: "Insurance Company Name",
  auto_order_previous_date_of_expiry: "Date of Expiry",
  auto_order_permanent_address: "Permanent Address",
  auto_order_current_address: "Current Address",
  auto_order_city: "City",
  auto_order_proposer_details_edit: "Edit",
  auto_order_mother_maiden_name: "Mother's Maiden Name",
  auto_order_maiden_name_error: "Numbers and special characters except hyphen are not allowed",
  auto_order_maiden_name_length_error: "Mother's Maiden Name must not be greater than 35 characters",
  auto_order_father_spouse_name_error: "Numbers and special characters except hyphen are not allowed",
  auto_order_father_spouse_name_length_error: "Father/Spouse Name must not be greater than 35 characters",

  auto_order_name_error: "Name is required",
  auto_order_name_validation_error: "Numbers and special characters except hyphen are not allowed",
  auto_order_name_length_error: "Name must not be greater than 35 characters",
  auto_order_date_of_birth_error: "Date of Birth is required",
  auto_order_cnic_error: "CNIC is required",
  auto_order_cnic_length_error: "CNIC Number should be 13 digits only",
  auto_order_cnic_issue_date_error: "CNIC issue date is required",
  auto_order_cnic_expiry_date_error: "CNIC expiry date is required",
  auto_order_cnic_issue_date_before_expiry_date_error: "CNIC Issue date should be before expiry date",
  auto_order_cnic_issue_date_five_year_before_expiry_date_error: "CNIC Expiry date should be at least 5 years after CNIC issue date",
  auto_order_date_of_birth_before_cnic_issue_date_error: "Date of birth should be before CNIC issue date",
  auto_order_cnic_issue_date_eighteen_year_before_cnic_issue_date_error: "CNIC Issue date should be at least 18 years after date of birth",
  auto_order_cnic_validation_error: "Incorrect format i.e 12345-4567896-6",
  auto_order_cnic_number_placeholder: "12345-4567896-6",
  auto_order_marital_status_error: "Martial status is required",
  auto_order_occupation_length_error: "Occupation must be smaller than 35 characters",
  auto_order_contact_number_error: "Contact number is required",
  auto_order_email_error: "Email Address is required",
  auto_order_email_validation: "Invalid Email",
  auto_order_permanent_address_error: "Permanent Address is required",
  auto_order_current_address_error: "Current Address is required",
  auto_order_permanent_address_length_error: "Permanent Address must not be greater than 100 characters",
  auto_order_previous_insurance_company_length_error: "Previous Company Name must not be greater than 100 characters",
  auto_order_current_address_length_error: "Current Address must not be greater than 100 characters",
  auto_order_city_error: "City is required",
  auto_order_same_as_permanent_address: "Same as permanent address",
  auto_order_occupation_validation_error: "Invalid Occupation",
  auto_order_holder_of_any_government_office: "Holder of any Government Office",
  auto_order_life_time: "Life time",
  auto_order_cnic_marital_status: "Marital Status",
  auto_order_documents: "Documents",
  auto_order_survey: "Survey Details",
  auto_order_id_subtitle: "Order ID: ",
  auto_order_beneficiary_details_title: "Beneficiary Details",
  auto_order_beneficiary_details: "Beneficiary Details",
  auto_order_beneficiary_details_name: "Full name",
  auto_order_beneficiary_details_contact_number: "Contact Number",
  auto_order_beneficiary_details_relation: "Relation",
  auto_order_beneficiary_details_other_info: "Other Info",
  auto_order_beneficiary_details_other_info_error: "Relation is required",
  auto_order_beneficiary_details_other_info_length_error: "Name must not be greater than 35 characters",
  auto_order_beneficiary_details_name_error: "Full name is required",
  auto_order_beneficiary_details_name_length_error: "Name must not be greater than 35 characters",
  auto_order_beneficiary_details_name_validation_error: "Numbers and special characters except hyphen are not allowed",
  auto_order_beneficiary_details_contact_number_error: "Contact number is required",
  auto_order_beneficiary_details_relation_error: "Relation is required",

  auto_order_documents_title: "Documents",
  auto_order_download_all_as_zip: "Download all as ZIP",
  auto_order_non_editable_document: "Cannot Edit _DOCUMENT_TYPE_",
  auto_order_no_document_attached: "No document Attached",
  auto_order_edit_documents_name: "Document Name",
  auto_order_edit_documents_name_error: "Document name is required",
  auto_order_edit_documents_name_length_error: "Document name must not be greater than 50 characters",

  auto_order_edit_documents_policy_id: "Policy ID",
  auto_order_edit_documents_policy_id_error: "Policy id is required",
  auto_order_edit_documents_policy_issue_date: "Policy Issue Date",
  auto_order_edit_documents_policy_expiry_date: "Policy Expiry Date",
  auto_order_edit_documents_policy_issue_date_error: "CNIC issue date is required",
  auto_order_edit_documents_policy_expiry_date_error: "CNIC expiry date is required",
  auto_order_edit_documents_policy_id_length_error: "Policy id must not be greater than 20 characters",
  auto_order_edit_documents_policy_id_validation_error: "Special characters are not allowed",

  auto_order_edit_documents_doc_type: "Documents Type",
  auto_order_edit_documents_doc_type_error: "Document type is required",
  auto_order_add_documents_upload_error: "Upload document is required",
  auto_order_add_documents_upload_document: "Upload Document",
  auto_order_add_documents_upload_text: "Upload",
  auto_order_add_documents_last_updated_text: "Last Updated",
  auto_order_upload_documents: "Uploaded Document",
  auto_order_upload_type: "Document Type",
  auto_order_last_updated: "Last Updated",

  auto_order_plan_details: "Plan Details",
  auto_order_plan_details_takaful_provider_details: "Takaful Provider Details",
  auto_order_plan_details_takaful_provider_name: "Takaful Provider Name",
  auto_order_plan_details_plan_name: "Plan Name",
  auto_order_plan_details_product_name: "Product Name",
  auto_order_plan_details_plan_type: "Plan Type",
  auto_order_plan_details_policy_id: "Policy ID",
  auto_order_plan_details_policy_issue_date: "Policy Issue Date",
  auto_order_plan_details_policy_expiry_date: "Policy Expiry Date",
  auto_order_plan_details_services: "Services",
  auto_order_plan_details_med_iq: "Med IQ",
  auto_order_plan_details_service_provider_2: "Service Provider 2",
  auto_order_plan_details_service_provider_3: "Service Provider 3",
  auto_order_plan_details_payment: "Payment",
  auto_order_plan_details_payment_frequency: "Payment Frequency",
  auto_order_plan_details_total_contribution: "Total Contribution",
  auto_order_plan_details_1st_month_installment: "1st Month Installment",
  auto_order_plan_details_11_months_installment: "11 Months Installment",
  auto_order_plan_details_service_provider: "Service Provider",
  auto_order_plan_details_price: "Price",
  auto_order_plan_details_service: "Service",

  auto_order_view_payment_title: "Payment",
  auto_order_view_payment_details_title: "Payment Details",
  auto_order_view_payment_details_total_contribution: "Total Contribution",
  auto_order_view_payment_details_frequency: "Frequency",
  auto_order_view_payment_details_payment_method: "Payment Method",
  auto_order_view_payment_month: "Month",
  auto_order_view_payment_amount: "Amount",
  auto_order_view_payment_status: "Status",
  auto_order_view_payment_contact_details_title: "Contact Details",
  auto_order_view_payment_pick_up_address: "Pick Up Address",
  auto_order_view_payment_contact_number: "Contact Number",
  auto_order_view_payment_status_title: "Payment Status",

  auto_order_vehicle_details_title: "Vehicle Details",
  auto_order_vehicle_details_car_make: "Car Make",
  auto_order_vehicle_details_car_model: "Car Model",
  auto_order_vehicle_details_manufacturing_year: "Manufacturing Year",
  auto_order_vehicle_details_car_value: "Car Value(Rs)",
  auto_order_vehicle_details_engine_number: "Engine Number",
  auto_order_vehicle_details_chassis_number: "Chassis Number",
  auto_order_vehicle_details_registration_number: "Registration Number",
  auto_order_vehicle_details_color: "Color",
  auto_order_vehicle_details_assembly: "Assembly",
  auto_order_vehicle_details_registration_province: "Registration Province",
  auto_order_vehicle_details_car_at_dealership: "Car At Dealership",
  auto_order_vehicle_details_engine_number_required: "Engine Number is required",
  auto_order_vehicle_details_chassis_number_required: "Chassis Number is required",
  auto_order_vehicle_details_registration_number_required: "Registration Number is required",
  auto_order_vehicle_details_color_required: "Color is required",
  auto_order_vehicle_details_registration_province_required: "Registration Province is required",
  auto_order_vehicle_details_is_at_dealership_required: "Field is required",
  auto_order_vehicle_details_dealership_name_required: "Dealership name is required",
  auto_order_vehicle_details_dealership_number_required: "Dealership number is required",
  auto_order_vehicle_details_assembly_required: "Assembly is required",
  auto_order_vehicle_details_engine_number_max_length: "Engine Number must be lesser than 15 characters",
  auto_order_vehicle_details_chassis_number_max_length: "Chassis Number must be lesser than 12 characters",
  auto_order_vehicle_details_registration_number_max_length: "Registration Number must be lesser than 10 characters",
  auto_order_vehicle_details_color_max_length: "Color must be lesser than 15 characters",
  auto_order_vehicle_details_dealership_name_max_length: "Dealership name must be lesser than 35 characters",
  auto_order_vehicle_details_engine_number_alpha_numeric: "Engine Number must be alpha numeric",
  auto_order_vehicle_details_chassis_number_alpha_numeric: "Chassis Number must be alpha numeric",
  auto_order_vehicle_details_registration_number_alpha_numeric: "Registration Number must be alpha numeric",
  auto_order_vehicle_details_color_alpha_numeric: "Color must be alpha numeric",

  auto_order_dealership_details_title: "Dealership Details",
  auto_order_dealership_details_dealer_ship_name: "Dealership Name",
  auto_order_dealership_details_dealer_ship_number: "Dealership Number",
  auto_order_add_survey_type_label: "Survey Type",
  auto_order_add_survey_type_required_error: "Survey Type is required",
  auto_order_date: "Date",
  auto_order_date_error: "Date is required",
  auto_order_time: "Time",
  auto_order_time_error: "Time is required",
  auto_order_survey_address: "Address",
  auto_order_survey_date: "Survey Date",
  auto_order_survey_time: "Survey Time",
  auto_order_survey_address_error_length_err: "Address must be smaller than 50 characters",
  auto_order_survey_address_error: "Address is required",
  auto_order_surveyor_add_company_city_label: "City",
  auto_order_surveyor_add_company_city_error: "City is required",
  auto_order_surveyor_instruction: "Instruction",
  auto_order_instruction_required_error: "Instruction is required",
  auto_order_instruction_length_error: "Instruction must be smaller than 250 characters",
  auto_order_surveyor_company_name: "Company",
  auto_order_company_name_required_error: "Company Name is required",
  auto_order_company_name_length_error: "Company must not be greater than 50 characters",
  auto_order_surveyor_name: "Surveyor Name",
  auto_order_surveyor_number: "Surveyor Number",
  auto_order_surveyor_number_error: "Surveyor Number is required",
  auto_order_surveyor_surveyor_details_heading: "Surveyor Details",
  auto_order_surveyor_survey_details_heading: "Survey Details",
  auto_order_surveyor_details_heading: "Surveyor Details",

  auto_order_surveyor_surveyor_name: "Surveyor Name",
  auto_order_add_survey_link_label: "Survey Link",
  auto_order_add_survey_video_date_time_label: "Survey Date and Time",
  auto_order_add_survey_location_label: "Survey Location",
  auto_order_surveyor_add_link: "Add Link",
  auto_order_surveyor_add_link_required_error: "Add Link is required",
  auto_order_surveyor_upload_survey_images: "Upload Survey Images",
  auto_order_surveyor_upload_images: "Upload Images",
  auto_order_surveyor_upload_images_acceptance: "Accepted file format: JPEG, PNG, PDF | File Size maximum 5 MB",

  auto_order_surveyor_surveyor_name_required_error: "Surveyor Name is required",
  auto_order_surveyor_surveyor_name_invalid_error: "Name does not contain special characters",
  auto_order_surveyor_surveyor_name_length_error: "Surveyor Name must be smaller than 30 characters",
  auto_order_surveyor_status: "Survey Status",
  auto_order_surveyor_report: "Survey Report",
  auto_order_surveyor_status_error: "Survey Status is required",
  auto_order_survey_report_message: "Auto Survey Report",
  auto_order_survey_image: "Survey Image",
  auto_order_survey_download_as_zip: "Download as ZIP",

  auto_order_documents_column: "Documents",
  auto_management_services_add_price_setup_selling_rate: "Min/Max Selling Rate",
  auto_management_services_add_price_setup_base_rate: "Base Rate",
  auto_management_services_add_price_setup_incentive_rate: "Min/Max Incentive Rate",

  /* shelfPlan price setup */
  auto_shelf_plans_add_price_setup_annual_pricing_title: "Annual Pricing",
  auto_shelf_plans_add_price_setup_monthly_pricing_title: "Monthly Pricing",
  auto_shelf_plans_add_price_setup_one_month_installment_range: "1 Month Installment Range",
  auto_shelf_plans_add_price_setup_eleven_month_installment_range: "11 Month Installment Range",
  auto_shelf_plans_add_price_setup_admin_cost_title: "Admin Cost",
  auto_shelf_plans_add_price_setup_pricing_title: "Pricing",
  auto_shelf_plans_add_price_setup_add_row: "Add Row",
  auto_shelf_plans_add_price_setup_listing_make: "Make",
  auto_shelf_plans_add_price_setup_listing_make_required: "Make is required",
  auto_shelf_plans_add_price_setup_listing_assembly: "Assembly",
  auto_shelf_plans_add_price_setup_listing_assembly_required: "Assembly is required",
  auto_shelf_plans_add_price_setup_listing_variant: "Variant",
  auto_shelf_plans_add_price_setup_listing_variant_required: "Variant is required",
  auto_shelf_plans_add_price_setup_listing_trip_plan_required: "Trip Plan is required",
  auto_shelf_plans_add_price_setup_listing_model: "Model",
  auto_shelf_plans_add_price_setup_listing_model_required: "Model is required",
  auto_shelf_plans_add_price_setup_listing_year_range: "Year Range",
  auto_shelf_plans_add_price_setup_takaful_bazaar_commission: "Takaful Bazaar Commission",
  auto_shelf_plans_add_price_setup_listing_commission: "Commission",
  auto_shelf_plans_add_price_setup_listing_incentive: "Incentive",
  auto_shelf_plans_add_price_setup_listing_incentive_min: "Incentive (Min)",
  auto_shelf_plans_add_price_setup_listing_incentive_max: "Incentive (Max)",
  auto_shelf_plans_add_price_setup_listing_builtin_incentive: "Built-in Incentive",
  auto_shelf_plans_add_price_setup_listing_net_premium: "Net Premium",
  auto_shelf_plans_add_price_setup_listing_gross_premium: "Gross Premium",
  auto_shelf_plans_add_price_setup_listing_brand_royalty_range: "Brand Royalty Range",
  auto_shelf_plans_add_price_setup_listing_dealership_incentive_range: "Dealership Incentive Range",
  auto_shelf_plans_add_price_setup_listing_dealership_points_range: "Dealership Points Range",
  auto_shelf_plans_add_price_setup_listing_agent_service_charges_range: "Agent Service Charges Range",

  auto_shelf_plans_add_price_setup_incentive_min_required_error: "Minimum-Incentive is required",
  auto_shelf_plans_add_price_setup_incentive_min_maximum_error_in_percentage: "Minimum-Incentive must be equal to or less than two digits",
  auto_shelf_plans_add_price_setup_incentive_min_minimum_error_in_percentage: "Minimum-Incentive must be positive",
  auto_shelf_plans_add_price_setup_incentive_min_minimum_decimal_error_in_percentage: "Minimum-Incentive must not contain more than 2 decimal points",
  auto_shelf_plans_add_price_setup_incentive_min_maximum_error_in_non_percentage: "Minimum-Incentive must be equal to or less than five digits",
  auto_shelf_plans_add_price_setup_incentive_min_decimal_error_in_non_percentage: "Minimum-Incentive must not contain decimal points",

  auto_shelf_plans_add_price_setup_incentive_max_required_error: "Maximum-Incentive is required",
  auto_shelf_plans_add_price_setup_incentive_max_minimum_error_in_percentage: "Maximum-Incentive must be positive",
  auto_shelf_plans_add_price_setup_incentive_max_maximum_error_in_percentage: "Maximum-Incentive must be equal to or less than two digits",
  auto_shelf_plans_add_price_setup_incentive_max_minimum_decimal_error_in_percentage: "Maximum-Incentive must contain only 2 decimal points",
  auto_shelf_plans_add_price_setup_incentive_max_decimal_error_in_non_percentage: "Maximum-Incentive must contain only 2 decimal points",
  auto_shelf_plans_add_price_setup_incentive_max_maximum_error_in_non_percentage: "Maximum-Incentive must be equal to or less than five digits",
  auto_shelf_plans_add_price_setup_incentive_max_greater_than_min_error: "Maximum-Incentive must be equal to or greater than  Minimum-Incentive",
  auto_shelf_plans_add_price_setup_incentive_max_value_type_id_different_from_incentive_min_type_id_err:
    "Maximum-Incentive Provision type must be same as Minimum-Incentive Provision type",
  auto_shelf_plans_add_price_setup_provision_type_required_error: "Provision type is required",
  auto_shelf_plans_add_price_setup_incentive_max_value_different_from_incentive_min_value_in_digital_sell_point_err:
    "Maximum-Incentive must be equal to Minimum-Incentive in Digital Sell Point",

  auto_shelf_plans_add_price_setup_incentive_built_in_required_error: "Built-In Incentive is required",
  auto_shelf_plans_add_price_setup_incentive_built_in_maximum_error_in_percentage:
    "Built-In Incentive  must be must be equal to or less than two digits",
  auto_shelf_plans_add_price_setup_incentive_built_in_minimum_decimal_error_in_percentage: "Built-In Incentive must be contain only 2 decimal points",
  auto_shelf_plans_add_price_setup_incentive_built_in_maximum_error_in_non_percentage: "Built-In Incentive must be equal to or less than Six digits",
  auto_shelf_plans_add_price_setup_incentive_built_in_decimal_error_in_non_percentage: "Built-In Incentive must contain two decimal points",
  auto_shelf_plans_add_price_setup_incentive_built_in_minimum_error_in_percentage: "Built-In Incentive must be positive",
  auto_shelf_plans_add_price_setup_incentive_built_in_maximum_value_error: "Built-in Incentive must be less that or equal max incentive",

  auto_shelf_plans_add_price_setup_min_admin_cost_required_error: "Minimum Admin Cost is required",
  auto_shelf_plans_add_price_setup_min_admin_cost_minimum_error_in_percentage: "Minimum Admin Cost must be positive",
  auto_shelf_plans_add_price_setup_min_admin_cost_maximum_error_in_percentage: "Minimum Admin Cost must be must be equal to or less than two digits",
  auto_shelf_plans_add_price_setup_min_admin_cost_minimum_decimal_error_in_percentage: "Minimum Admin cost can be contain 2 decimal points",
  auto_shelf_plans_add_price_setup_min_admin_cost_maximum_error_in_non_percentage: "Minimum Admin Cost must be equal to or less than Five digits",
  auto_shelf_plans_add_price_setup_min_admin_cost_decimal_error_in_non_percentage: "Minimum Admin Cost must contain two decimals",

  auto_shelf_plans_add_price_setup_max_admin_cost_required_error: "Maximum Admin Cost is required",
  auto_shelf_plans_add_price_setup_max_admin_cost_minimum_error_in_percentage: "Maximum Admin Cost must be positive",
  auto_shelf_plans_add_price_setup_max_admin_cost_maximum_error_in_percentage: "Maximum Admin Cost must be must be equal to or less than two digits",
  auto_shelf_plans_add_price_setup_max_admin_cost_minimum_decimal_error_in_percentage: "Maximum Admin cost can be contain 2 decimal points",
  auto_shelf_plans_add_price_setup_max_admin_cost_maximum_error_in_non_percentage: "Maximum Admin Cost must be equal to or less than Five digits",
  auto_shelf_plans_add_price_setup_max_admin_cost_decimal_error_in_non_percentage: "Maximum Admin Cost must not contain more than two decimals",
  auto_shelf_plans_add_price_setup_max_admin_cost_value_type_id_different_from_min_admin_cost_value_type_id_err:
    "Maximum Admin Cost Provision type must be same as Minimum Admin Cost Provision type",
  auto_shelf_plans_add_price_setup_max_admin_cost_greater_than_min_error: "Maximum Admin Cost must be equal to or greater than  Minimum Admin Cost",

  auto_shelf_plans_add_price_setup_listing_year_range_min_required: "Minimum year is required",

  auto_shelf_plans_add_price_setup_listing_year_range_max_required: "Maximum year is required",
  auto_shelf_plans_add_price_setup_listing_range_duplicate_error: "Duplicate range is not allowed",

  auto_shelf_plans_add_price_setup_listing_year_range_max_greater_than_min_error:
    "Maximum year range must be equal to or greater than  Minimum year range",

  auto_shelf_plans_add_price_setup_listing_net_rate_range: "Net Rate Range(%)",

  auto_shelf_plans_add_price_setup_listing_net_rate_range_min_required: "Minimum net rate is required",
  auto_shelf_plans_add_price_setup_listing_net_rate_range_min_maximum_error: "Minimum net rate must be equal to or less than two digits",
  auto_shelf_plans_add_price_setup_listing_net_rate_range_min_minimum_decimal_error_in_percentage:
    "Minimum net rate must not contain more than 3 decimal points",
  auto_shelf_plans_add_price_setup_listing_net_rate_range_min_positive_error: "Minimum net rate must be positive",

  auto_shelf_plans_add_price_setup_listing_net_rate_range_max_required: "Maximum net rate is required",
  auto_shelf_plans_add_price_setup_listing_net_rate_range_max_positive_error: "Maximum net rate must be positive",
  auto_shelf_plans_add_price_setup_listing_net_rate_range_max_minimum_error: "Maximum net rate must be equal to or less than two digits",
  auto_shelf_plans_add_price_setup_listing_net_rate_range_max_minimum_decimal_error: "Maximum net rate must contain only 3 decimal points",
  auto_shelf_plans_add_price_setup_listing_net_rate_range_max_greater_than_min_error:
    "Maximum net rate must be equal to or greater than  Minimum net rate",

  auto_shelf_plans_add_price_setup_listing_value_range: "Value Range",

  auto_shelf_plans_add_price_setup_listing_value_range_min_required: "Minimum value range is required",
  auto_shelf_plans_add_price_setup_listing_value_range_min_maximum_error: "Minimum value range must be equal to or less than 9 digits",
  auto_shelf_plans_add_price_setup_listing_value_range_min_minimum_decimal_error_in_percentage: "Minimum value range must not contain decimal points",
  auto_shelf_plans_add_price_setup_listing_value_range_min_positive_error: "Minimum value range must be positive",

  auto_shelf_plans_add_price_setup_listing_value_range_max_required: "Maximum value range is required",
  auto_shelf_plans_add_price_setup_listing_value_range_max_positive_error: "Maximum value range must be positive",
  auto_shelf_plans_add_price_setup_listing_value_range_max_minimum_error: "Maximum value range must be equal to or less than 9 digits",
  auto_shelf_plans_add_price_setup_listing_value_range_max_minimum_decimal_error: "Maximum value range must not contain decimal points",
  auto_shelf_plans_add_price_setup_listing_value_range_max_greater_than_min_error:
    "Maximum value range must be equal to or greater than  Minimum value range",

  auto_shelf_plans_add_price_setup_listing_base_rate: "Base Rate(%)",

  auto_shelf_plans_add_price_setup_listing_base_rate_max_required: "Maximum base rate is required",
  auto_shelf_plans_add_price_setup_listing_base_rate_max_positive_error: "Maximum base rate must be positive",
  auto_shelf_plans_add_price_setup_listing_base_rate_max_minimum_error: "Maximum base rate must be equal to or less than 2 digits",
  auto_shelf_plans_add_price_setup_listing_base_rate_max_minimum_decimal_error: "Maximum base rate must contain only 3 decimal points",

  auto_shelf_plans_add_price_setup_listing_commission_required: "Commission is required",
  auto_shelf_plans_add_price_setup_listing_commission_positive_error: "Commission must be positive",
  auto_shelf_plans_add_price_setup_listing_commission_minimum_error: "Commission must be equal to or less than 2 digits",
  auto_shelf_plans_add_price_setup_listing_commission_maximum_error: "Commission must not be greater than 100",
  auto_shelf_plans_add_price_setup_listing_commission_minimum_decimal_error: "Commission contain only 3 decimal points",

  auto_shelf_plans_add_price_setup_listing_estimated_gross_rate_range: "Estimated Gross Rate Range(%)",
  auto_shelf_plans_add_price_setup_listing_tb_incentive_range: "TB Incentive Range(%)",

  auto_shelf_plans_add_price_setup_listing_tb_incentive_range_min_required: "Minimum tb incentive is required",
  auto_shelf_plans_add_price_setup_listing_tb_incentive_range_min_maximum_error: "Minimum tb incentive must be equal to or less than two digits",
  auto_shelf_plans_add_price_setup_listing_tb_incentive_range_min_minimum_decimal_error_in_percentage:
    "Minimum tb incentive must not contain more than 3 decimal points",
  auto_shelf_plans_add_price_setup_listing_tb_incentive_range_min_positive_error: "Minimum tb incentive must be positive",
  auto_shelf_plans_add_price_setup_listing_tb_incentive_range_max_required: "Maximum tb incentive is required",
  auto_shelf_plans_add_price_setup_listing_tb_incentive_range_max_positive_error: "Maximum tb incentive must be positive",
  auto_shelf_plans_add_price_setup_listing_tb_incentive_range_max_minimum_error: "Maximum tb incentive must be equal to or less than two digits",
  auto_shelf_plans_add_price_setup_listing_tb_incentive_range_max_minimum_decimal_error: "Maximum tb incentive must contain only 3 decimal points",
  auto_shelf_plans_add_price_setup_listing_tb_incentive_range_max_greater_than_min_error:
    "Maximum tb incentive must be equal to or greater than  Minimum tb incentive",

  auto_shelf_plans_add_price_setup_listing_first_month_range: "1 Month Range(Rs)",
  auto_shelf_plans_add_price_setup_listing_eleven_month_range: "11 Month Range(Rs)",

  auto_shelf_plans_services_listing_title: "Services",
  auto_order_payment_order_id: "Order Id:",
  plan_max_age_max_error: "Max age can not be greater than 100",
  plan_max_age_equal_to_min_age: "Max and min age can not be equal"
};
